import React, { useState } from 'react'
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';
import { SET_ONBOARDING_IS_LOADING, SET_ONBOARDING_IS_PREMIUM, SET_ONBOARDING_STEP } from '../../../redux/actions/types';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import './index.css';


const topics = [{
    id: 1,
    img: 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/%20animation/Group%2023332%20(2).png',
    text : '⚡Personalised & Fast',
} , {
    id : 2,
    img: 'https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/%20animation/Group%2023332%20(3).png',
    text : 'Standard & Slow'
}]
const LcpCourse = ({razorpayHandler, handleOnboardingCompletion}) => {

    const [selectedIndex , setSelectedIndex] = useState(1);
    const dispatch = useDispatch();

  return (
    <div className='w-full'>
        <div className="w-full p-3  rounded-[12px]" style={{backgroundImage : `linear-gradient(
  to bottom,
  rgba(64,106,255,0.15) 0%,
  rgba(25,46,66,0.15) 100%
)`}}>
    <div className='w-full flex items-center h-[44px] justify-center rounded-[24px] bg-[#12285a] p-[2px]'>
        {topics?.map((topic) => (
            <div key={topic.id} className={`w-full cursor-pointer flex items-center justify-center rounded-[24px] ${selectedIndex === 1 ? topic.id === 1 ? 'border-[1px] border-[#2BBD13]' : 'none' : selectedIndex === 2 ? topic.id === 2 ? 'border-[1px]  border-[#EF9121]' : 'none' : 'none'} ${selectedIndex === topic.id && 'h-full bg-[#406AFF]/50'}`} onClick={() => setSelectedIndex(topic.id)}>
                <p className={`text-[12px] flex items-center font-medium ${selectedIndex === topic.id ? 'text-white' : 'text-[#70AEFF]'}`}>{topic?.text} {selectedIndex === 2 && topic.id === 1 && <div className='w-[6px] h-[6px] rounded-full bg-[#2BBD13] ml-2' />} {selectedIndex === 1 && topic.id === 2 && <div className='w-[6px] h-[6px] rounded-full bg-[#EF9121] ml-2' />}</p>
            </div>
        ))}
    </div>
    {/* <div className='w-full mt-6 relative'>
        {topics?.map((topic) => (
            <img 
                key={topic.id}
                alt="" 
                src={topic.img}
                className={`w-full transition-opacity duration-300 ${
                    selectedIndex === topic.id ? 'opacity-100' : 'opacity-0 absolute top-0 left-0'
                }`}
            />
        ))}
    </div>
     */}
   
   {/* Preload both images and use opacity transitions for smooth switching */}
   <div className='w-full mt-6 relative'>
        {topics?.map((topic) => (
            <div key={topic.id} className={`w-full transition-opacity duration-300 ${
                selectedIndex === topic.id ? 'opacity-100 relative' : 'opacity-0 absolute top-0 left-0'
            }`}>
                <img src={topic.img} alt="" />
                
                {/* Check mark for first option - only visible and animated when selectedIndex is 1 */}
                {selectedIndex === 1 && topic.id === 1 && (
                    <div key={`check-${selectedIndex}`} className='absolute left-[30%] md:left-[29%] top-[50%] w-[18px] h-[18px] md:w-[24px] md:h-[24px] flex justify-center items-center -translate-x-1/2 -translate-y-1/2 flex-shrink-0 bg-[#2BBD13] p-1 rounded-full pop-check-animation'>
                        <FontAwesomeIcon icon={faCheck} className='text-white' size='xs' />
                    </div>
                )}
                
                {/* Orange close mark for first option - visible when showing first image but selectedIndex is 2 */}
                {topic.id === 1 && selectedIndex === 1 && (
                    <div className='absolute right-[24%] md:right-[26%] top-[50%] w-[18px] h-[18px]  md:w-[24px] md:h-[24px] flex justify-center items-center -translate-x-1/2 -translate-y-1/2 flex-shrink-0 bg-[#EF9121] p-1 rounded-full opacity-50 fade-transition'>
                        <FontAwesomeIcon icon={faClose} className='text-white' size='xs' />
                    </div>
                )}
                
                {/* Check mark for second option - visible when showing second image but selectedIndex is 1 */}
                {topic.id === 2 && selectedIndex === 2 && (
                    <div className='absolute left-[30%] md:left-[29%] top-[50%] w-[18px] h-[18px] md:w-[24px] md:h-[24px] flex justify-center items-center -translate-x-1/2 -translate-y-1/2 flex-shrink-0 bg-[#2BBD13] p-1 rounded-full opacity-50 fade-transition'>
                        <FontAwesomeIcon icon={faCheck} className='text-white' size='xs' />
                    </div>
                )}
                
                {/* Orange close mark for second option - only visible and animated when selectedIndex is 2 */}
                {topic.id === 2 && selectedIndex === 2 && (
                    <div key={`close-${selectedIndex}`} className='absolute right-[24%] md:right-[26%] top-[50%] w-[18px] h-[18px] md:w-[24px] md:h-[24px] flex justify-center items-center -translate-x-1/2 -translate-y-1/2 flex-shrink-0 bg-[#EF9121] p-1 rounded-full pop-close-animation'>
                        <FontAwesomeIcon icon={faClose} className='text-white' size='xs' />
                    </div>
                )}
            </div>
        ))}
    </div>



        </div>

        <div className='px-[1px] pb-[1px] rounded-lg' style={{backgroundImage : `radial-gradient(closest-side, #8BD845 0%, #C5E2AB 100%)`}}>
            <button className="mt-6 flex h-[52px] items-center justify-center gap-2.5 px-[90px] py-3 relative self-stretch w-full bg-[#7fc241] rounded-lg shadow-[0px_0px_10px_#7fc24159] hover:bg-[#7fc241]/90 border-0 cursor-pointer" onClick={() => 
                
                {
                    dispatch({type : SET_ONBOARDING_IS_PREMIUM, payload : true})
                    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_PREMIUM_BUTTONS_CLICKED);
                    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_COURSE_PAGE_GET_MY_PERSONALISED_COURSE_BUTTON_CLICKED);
                razorpayHandler()
            }}>
            <div className="inline-flex flex-col items-center justify-center gap-1 relative flex-[0_0_auto] mt-[-5.00px] mb-[-5.00px]">
                <span className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#121212] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                Get My Personalised Course
                </span>

                <p className="relative flex items-center justify-center w-fit [font-family:'Inter',Helvetica] font-normal text-transparent text-xs text-center tracking-[0] leading-[normal]">
                <span className="font-medium text-[#121212b2]">
                    Early Bird Discount:{" "}
                </span>

                <span className="font-semibold text-[#121212b2]">₹399</span>

                <span className="font-medium text-[#121212b2]">&nbsp;</span>

                <span className="font-medium text-[#e06064] line-through">
                    ₹999
                </span>
                </p>
            </div>
            </button>
        </div>

        <div className='mt-3 text-white/70 text-[14px] text-center'>OR</div>

        <button className="mt-3 flex h-[52px] items-center justify-center gap-2.5 px-[90px] py-3 relative self-stretch w-full  rounded-lg border-2 border-[#EF9121] cursor-pointer" onClick={() => 
            {
                dispatch({type : SET_ONBOARDING_IS_PREMIUM, payload : false})
                dispatch({type : SET_ONBOARDING_IS_LOADING, payload : true})
                Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_COURSE_PAGE_LET_ME_TRY_FREE_STANDARD_COURSE_BUTTON_CLICKED);
                //handleOnboardingCompletion()
            }}>
          <div className="inline-flex flex-col items-center justify-center gap-1 relative flex-[0_0_auto] mt-[-5.00px] mb-[-5.00px]">
            <span className="relative flex items-center justify-center w-fit mt-[-1.00px] [font-family:'Inter',Helvetica] font-semibold text-[#EF9121] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
            Let Me Try Free Standard Course
            </span>

            <p className="relative flex items-center justify-center w-fit [font-family:'Inter',Helvetica] font-normal text-transparent text-xs text-center tracking-[0] leading-[normal]">
              <span className="font-medium text-white/70 text-[12px]">
              No Certificate Included*{" "}
              </span>
            </p>
          </div>
        </button>

    </div>
  )
}

export default LcpCourse